[
  {
    "id": "socialdemokraterna",
    "name": "Socialdemokraterna",
    "abbreviation": "S",
    "color": "#ED1B34",
    "person": {
      "name": "Karin Rosendal",
      "title": "Djurpolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "moderaterna",
    "name": "Moderaterna",
    "abbreviation": "M",
    "color": "#1B49DD",
    "person": {
      "name": "Erik Lundqvist",
      "title": "Landsbygdspolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "sverigedemokraterna",
    "name": "Sverigedemokraterna",
    "abbreviation": "SD",
    "color": "#DDDD00",
    "person": {
      "name": "Anna Svensson",
      "title": "Jordbrukspolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "miljopartiet",
    "name": "Miljöpartiet",
    "abbreviation": "MP",
    "color": "#83CF39",
    "person": {
      "name": "Lisa Grönberg",
      "title": "Djurpolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "centerpartiet",
    "name": "Centerpartiet",
    "abbreviation": "C",
    "color": "#009933",
    "person": {
      "name": "Björn Eklund",
      "title": "Landsbygdspolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "vansterpartiet",
    "name": "Vänsterpartiet",
    "abbreviation": "V",
    "color": "#DA291C",
    "person": {
      "name": "Fatima Holm",
      "title": "Djurrättspolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "liberalerna",
    "name": "Liberalerna",
    "abbreviation": "L",
    "color": "#006AB3",
    "person": {
      "name": "Johan Lindström",
      "title": "Miljöpolitisk talesperson",
      "image": "placeholder.svg"
    }
  },
  {
    "id": "kristdemokraterna",
    "name": "Kristdemokraterna",
    "abbreviation": "KD",
    "color": "#005EA1",
    "person": {
      "name": "Maria Bergström",
      "title": "Familjepolitisk talesperson",
      "image": "placeholder.svg"
    }
  }
]
